import { gql } from '@apollo/client'
import { NOTIFICATION_FIELDS } from './fragments/notification'

export const DISMISS_LIVE_NOTIFICATION = gql`
  ${NOTIFICATION_FIELDS}
  mutation dismissLiveNotification($id: ID!) {
    dismissLiveNotification(id: $id) {
      id
      notification {
        ...NotificationFields
      }
    }
  }
`
